import React, { useCallback } from "react";
import classnames from "classnames";
import MediaQuery from "components/MediaQuery";
import DefaultSelect from "components/DefaultSelect";
import { ReactComponent as TriangleArrowDown } from "svg/triangle-arrow-down.svg";
import { QUEUE_TYPE_OPTIONS } from "./played-champions-filters";

const ChampionsFilters = (props) => {
  const { filters, setFilters, setFiltersChanged } = props;

  const onFilterChange = useCallback(
    (type, option) => {
      setFiltersChanged(true);
      setFilters({ ...filters, [type]: option.value });
    },
    [filters],
  );

  const getLabel = (options, value) => {
    const foundOption = options.find((option) => option.value === value);
    return (foundOption && foundOption.label) || "";
  };

  const Filters = ({ isMobile }) => (
    <React.Fragment>
      <DefaultSelect
        title={"Change Queue Type"}
        group={"queueType"}
        customButton={
          <div className="filter-select_mobile">
            <span>{getLabel(QUEUE_TYPE_OPTIONS, filters.queueType)}</span>
            <TriangleArrowDown className="dropdown-indicator" />
          </div>
        }
        className={`filter-select-transparent`}
        isMobile={isMobile}
        options={QUEUE_TYPE_OPTIONS}
        onChange={(selected) => {
          onFilterChange("queueType", selected);
        }}
        value={filters.queueType}
        width={110}
        fontSize={12}
        isSearchable={false}
      />
    </React.Fragment>
  );

  return (
    <div className="match-block_filters">
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        {(mediaQueryClassNames) => (
          <div className={classnames(mediaQueryClassNames, "flex-center")}>
            <Filters />
          </div>
        )}
      </MediaQuery>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
        {(mediaQueryClassNames) => (
          <div className={classnames(mediaQueryClassNames, "flex-center")}>
            <Filters isMobile />
          </div>
        )}
      </MediaQuery>
    </div>
  );
};

export default ChampionsFilters;
